// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-header {
  font-size: 0.75rem;
  font-weight: 500;
}
.time-header .server-time {
  color: var(--online-time-color);
}
.time-header .online-time {
  color: var(--online-time-color);
}
@media screen and (max-width: 576px) {
  .time-header {
    font-size: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/online-time/online-time.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACE;EACE,+BAAA;AACJ;AAEE;EACE,+BAAA;AAAJ;AAGE;EAZF;IAaI,iBAAA;EAAF;AACF","sourcesContent":[".time-header {\n  font-size: 0.75rem;\n  font-weight: 500;\n\n  .server-time {\n    color: var(--online-time-color);\n  }\n\n  .online-time {\n    color: var(--online-time-color);\n  }\n\n  @media screen and (max-width: 576px) {\n    font-size: 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
